import { Checkmark } from '@/components/icons/Checkmark';
import { Flex, Stack, Text, useMantineTheme } from '@mantine/core';
import { ReactNode } from 'react';

interface Props {
  isPartnershipPreset: boolean;
  partnership: string;
}

export const FinancialAidBullets = ({ isPartnershipPreset, partnership }: Props) => {
  const theme = useMantineTheme();

  const refundableBullet = (
    <>
      The EZ File fee is{' '}
      <Text
        span
        fw={700}
        inherit
      >
        100% refundable
      </Text>{' '}
      if we cannot find you savings
    </>
  );

  const bullets: ReactNode[] = isPartnershipPreset
    ? [
        <>
          EZ File is{' '}
          <Text
            span
            fw={700}
            inherit
          >
            free
          </Text>{' '}
          for {partnership} members
        </>,
        'The filing process* takes between 15-30 minutes',
        "If EZ File doesn't find you financial aid, we can try to find you savings another way",
      ]
    : [
        'For those who qualify, EZ File is normally the most cost-effective option',
        'The filing process* takes between 15-30 minutes',
        refundableBullet,
      ];

  return (
    <Stack
      spacing={16}
      maw={620}
    >
      <Stack spacing={12}>
        {bullets.map((b, i) => (
          <Flex
            key={i}
            gap={12}
            align="flex-start"
          >
            <Checkmark
              style={{
                color: theme.colors.tertiary[3],
                flexShrink: 0,
                marginTop: 2,
              }}
            />
            <Text
              size={16}
              c="white"
            >
              {b}
            </Text>
          </Flex>
        ))}
      </Stack>
      <Text
        size={13}
        c="primary.2"
        fs="italic"
      >
        *{' '}
        <Text
          span
          fw={700}
          inherit
        >
          EZ File
        </Text>{' '}
        will require you to disclose certain assets in order to determine eligibility.
      </Text>
    </Stack>
  );
};
